import { IRemoteFilterGetter } from '../@types/entityTypes';
import { BooleanOperator, FilterOperation, IFilterInput } from '../graphql/schema/p4types';

/**
 * Construct a filter getter that OR's together the specified field keys as contains filters.
 * @param fieldKeys - Keys of the entity to filter on (Such as 'orderNumber', 'reference', etc)
 */
export const orRemoteFilterGetter: (fieldKeys: Array<string>) => IRemoteFilterGetter = (fieldKeys) => {
  return ({ fieldValue }: { fieldValue: any }) => {
    //Build 'contains' filters for all the label keys.
    const orFilters = fieldKeys.map<IFilterInput>((fieldName) => ({
      filterOperation: FilterOperation.Contains,
      filterParameters: {
        field: fieldName,
        value: fieldValue,
      },
    }));
    //Structure them for 'OR' combination.
    const filter: IFilterInput = {
      filterParameters: {
        filters: orFilters,
        booleanOperator: BooleanOperator.Or,
      },
    };
    //Return as filter list for passing through to the query.
    return [filter];
  };
};
